import searchQueryState from './SearchQuery'
import searchConfig from './SearchConfiguration'

export default {
  useRouterHelper(router) {
    const {
      getActiveConfig
    } = searchConfig.searchConfigurationUse()

    const { searchQuery, groupByCategories } = searchQueryState.searchQueryUse()

    function updateRoute() {
      const query = {}

      const config = getActiveConfig()
      const filterParams = searchQuery.activeCategories
        .map((category) => category.slug).filter((x) => x)
        .sort().join('+')

      if (filterParams !== '') {
        query.filters = filterParams
      }

      const termsUrl = searchQuery.terms.sort().join('+')
      if (termsUrl !== '') {
        query.query = termsUrl
      }

      const defaultSorting = config.sortingOptions.find((x) => x.default).value
      if (searchQuery.sorting && searchQuery.sorting !== defaultSorting && !groupByCategories) {
        query.sorting = searchQuery.sorting
      }

      if (config.viewOptions && config.viewOptions.length > 1) {
        const defaultView = config.viewOptions.find((x) => x.default).value
        if (searchQuery.view && searchQuery.view !== defaultView) {
          query.sorting = searchQuery.sorting
        }
      }

      router.push({
        query
      }).catch(() => {})
    }

    function getRouteData() {
      const { filters } = router.currentRoute.query
      const activeFiltersSlugs = (filters || '').split('+').filter((t) => t)

      const config = getActiveConfig()
      const searchType = config.type

      const activeCategories = config.categories.flatMap((a) => a.items)
        .filter((x) => activeFiltersSlugs.includes(x.slug))

      const terms = (router.currentRoute.query.query || '').split('+').filter((t) => t)
      const sorting = router.currentRoute.query.sorting || null
      const view = router.currentRoute.query.view || null

      return {
        activeCategories,
        searchType,
        terms,
        sorting,
        view
      }
    }

    return {
      getRouteData,
      updateRoute
    }
  }
}
